import alert from '@/plugins/alert'
import router from '@/router'
import api from '../../plugins/api'
import {
  Staff,
  Teacher,
  Student,
  Otp,
  Accountant,
  EducationManager,
  SuperAdmin
} from '@/plugins/api'
import _ from 'lodash'
export default {
  namespaced: true,
  state: {
    user: null,
    jwt: null,
    profile: {},
    role: {},
    isAuthenticated: false,
    showingOtpDialog: false,
    otpDialogInitCallback: () => {
      console.log('mock init')
    },
    otpDialogSuccessCallback: () => {
      console.log('mock success callback')
    },
    otpDialogValidateCallback: () => {
      console.log('mock validate callback')
    },
    loadingOtp: false
  },
  actions: {
    async signIn({ commit }, { identifier = '', password = '' } = {}) {
      try {
        const { jwt, user } = await api.Auth.create({ identifier, password })
        commit('setUser', { user, jwt })
        if (user.role.type === 'teacher') {
          router.push('/teacher-dashboard')
        } else if (user.role.type === 'student') {
          router.push('/student-dashboard')
        } else {
          router.push('/')
        }
      } catch (error) {
        console.error('signIn', error)
      }
    },
    async resendOtp({ commit }, user) {
      try {
        commit('setLoadingOtp', true)
        await Otp.create({ user })
        commit('setLoadingOtp', false)
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async signInWithOtp({ commit }, { identifier = '', password = '' } = {}) {
      try {
        const { jwt, user } = await api.Auth.create({ identifier, password })
        commit('setShowingOtpDialog', true)
        commit('setOtpCallback', {
          otpDialogSuccessCallback: () => {
            commit('setUser', { user, jwt })
            if (user.role.type === 'teacher') {
              router.push('/teacher-dashboard')
            } else if (user.role.type === 'student') {
              router.push('/student-dashboard')
            } else {
              router.push('/')
            }
            commit('setShowingOtpDialog', false)
          },
          otpDialogInitCallback: async () => {
            try {
              commit('setLoadingOtp', true)
              await Otp.create({ user: user.id })
            } catch (error) {
              console.error(error)
              throw error
            } finally {
              commit('setLoadingOtp', false)
            }
          },
          otpDialogValidateCallback: async otp => {
            try {
              await Otp.validate({ user: user.id, otp })
            } catch (error) {
              console.error(error)
              throw error
            }
          }
        })

        if (user.role.type === 'teacher') {
          router.push('/teacher-dashboard')
        } else if (user.role.type === 'student') {
          router.push('/student-dashboard')
        } else {
          router.push('/')
        }
        return user
      } catch (error) {
        console.error('signIn', error)
        throw error
      }
    },
    signOut() {
      this.reset()
      router.push('signIn')
    },
    setRole({ commit }, role) {
      commit('setRole', role)
    },
    async fetchProfile({ commit, state }, { roleType, query }) {
      if (!roleType) return
      const profile =
        roleType === 'manager'
          ? await Staff.fetch(query)
          : roleType === 'accountant'
          ? await Accountant.fetch(query)
          : roleType === 'education_manager'
          ? await EducationManager.fetch(query)
          : await SuperAdmin.fetch(query)

      commit('setProfile', await profile)
    },
    async fetchTeacher({ commit }, query) {
      commit('setProfile', await Teacher.fetch(query))
    },
    async fetchStudent({ commit }, query) {
      commit('setProfile', await Student.fetch(query))
    },
    signUp(context, credentials = {}) {},
    async forgotPassword(context, email) {
      await api.Auth.forgotPassword(email)
      alert.success('Hãy kiểm tra mail của bạn')
    },
    async resetPassword({ commit }, { code, password, passwordConfirmation }) {
      const { user, jwt } = await api.Auth.resetPassword(code, password, passwordConfirmation)
      commit('setUser', { user, jwt })
      if (user.role.type === 'teacher') {
        router.push('/teacher-dashboard')
      } else if (user.role.type === 'student') {
        router.push('/student-dashboard')
      } else {
        router.push('/')
      }
    }
  },
  mutations: {
    setUser(state, { user, jwt }) {
      state.jwt = jwt
      state.user = user
      if (user) {
        state.role = user.role
        state.isAuthenticated = true
      } else {
        state.isAuthenticated = false
        state.role = null
      }
    },
    setShowingOtpDialog(state, value) {
      state.showingOtpDialog = value
    },
    setLoadingOtp(state, value) {
      state.loadingOtp = value
    },
    setOtpCallback(
      state,
      { otpDialogInitCallback, otpDialogSuccessCallback, otpDialogValidateCallback }
    ) {
      if (otpDialogInitCallback) {
        state.otpDialogInitCallback = otpDialogInitCallback
      }
      if (otpDialogValidateCallback) {
        state.otpDialogValidateCallback = otpDialogValidateCallback
      }
      if (otpDialogSuccessCallback) {
        state.otpDialogSuccessCallback = otpDialogSuccessCallback
      }
    },
    setRole(state, role) {
      state.role = role
    },
    setProfile(state, profile) {
      state.profile = _.get(profile, '0', {})
    }
  },
  getters: {
    jwt(state) {
      return state.jwt
    },
    user(state) {
      return !state.user ? {} : state.user
    },
    role(state) {
      return state.role || state.user.role || {}
    },
    profile(state) {
      return !state.profile ? {} : state.profile
    },
    isAuthenticated(state) {
      return state.isAuthenticated
    }
  }
}
